import React from 'react'
import PropTypes from 'prop-types'

import Modal from '@components/modal'
import Loading from '..'

const LoadingModal = ({ isOpen }) => (
  <Modal isOpen={isOpen} style={{ backgroundColor: 'transparent' }}>
    <Loading height={40} width={40} />
  </Modal>
)

LoadingModal.propTypes = {
  isOpen: PropTypes.bool,
}

LoadingModal.defaultProps = {
  isOpen: false,
}

export default LoadingModal
